import { render, staticRenderFns } from "./FaceRecoImageDialog.vue?vue&type=template&id=1e75beb2&scoped=true"
import script from "./FaceRecoImageDialog.vue?vue&type=script&lang=js"
export * from "./FaceRecoImageDialog.vue?vue&type=script&lang=js"
import style0 from "./FaceRecoImageDialog.vue?vue&type=style&index=0&id=1e75beb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e75beb2",
  null
  
)

/* custom blocks */
import block0 from "./FaceRecoImageDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports